<div class="login-container">
    <button mat-raised-button color="primary" (click)="login()">Log ind</button>
</div>